import React from 'react';

import useLazyQuery from '../../../../../../../../surveys/hooks/useLazyQuery';

import { GET_COMMUNITIES } from '../../../../../../../../graphql/Survey';

import { COMMUNITY_DASHBOARD_FILTER_TYPE_NAMES } from '../../../../../../helpers/constants';

import SearchDropdown from '../SearchDropdown/SearchDropdown';

import deleteIcon from '../../../../../../../../assets/img/delete.svg';

import styles from './CommunityTagsFilter.module.css';

export default ({
  singleFilterIndex,
  appliedFilters,
  setAppliedFilters,
  onFilterSelectCompleted,
  onTypeChange,
  getTypeOptions
}) => {
  const singleFilter = appliedFilters[singleFilterIndex];

  const searchCommunityTagValuesApi = useLazyQuery(GET_COMMUNITIES, {
    fetchPolicy: 'no-cache'
  });

  const searchCommunityTagValues = async (page, search) => {
    const preparedAppliedFilters = { ...singleFilter.tags };
    delete preparedAppliedFilters.tagValue;

    const searchResults = await searchCommunityTagValuesApi({
      variables: {
        ...preparedAppliedFilters,
        start: 0,
        end: (page + 1) * 10,
        search,
        salt: Math.random().toString()
      }
    });
    return searchResults &&
      searchResults.data &&
      searchResults.data.getCommunities &&
      searchResults.data.getCommunities.communityTags
      ? searchResults.data.getCommunities.communityTags.map(o => ({
          label: o,
          value: o
        }))
      : [];
  };

  return (
    <div className={styles.container}>
      <SearchDropdown
        fetchOptions={getTypeOptions}
        placeholder="Select a filter type"
        onSelectCompleted={value => onTypeChange(value)}
        value={{
          value: singleFilter.type,
          label: COMMUNITY_DASHBOARD_FILTER_TYPE_NAMES[singleFilter.type]
        }}
        search={false}
        hideNoValueOption
      />
      <SearchDropdown
        fetchOptions={searchCommunityTagValues}
        placeholder="Tag value"
        onSelectCompleted={value =>
          onFilterSelectCompleted('name', value, 'community')
        }
        value={{
          value: singleFilter.community.name,
          label: singleFilter.community.name
        }}
      />
      <img
        src={deleteIcon}
        className={styles.deleteIcon}
        onClick={() => {
          const newAppliedFilters = appliedFilters.filter(
            (aF, i) => i !== singleFilterIndex
          );
          setAppliedFilters(newAppliedFilters);
        }}
        alt="Delete filter"
        role="presentation"
      />
    </div>
  );
};
